const COLORS = {
  beige: "#FCF8F6",
  green: "#047E50",
  black: "#252525",
  silver: {
    50: "#B6B6B6",
  },
  red: "#d32f2f",
  border: "rgba(0, 0, 0, 0.12)"
};

export default COLORS;
